<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-11-25_pikkujoulut";
    let title = "Pikkujoulutreenit torstaina 28.11. klo 18!";
    let titlePic = "/svelte-site/img/ajankohtaista/Maija_Kirsi_pieni.jpg";
    let firstPara = "Virittäydytään pikkujoulutunnelmaan torstaina 28.11. klo 18 pikkujoulutreenin muodossa! ";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1>{title}</h1>
                    <p><b>Pikkujoulutreenit!</b></p>
                    <p>Luvassa on hyväntuulinen ja energinen treeni, joka sopii kaikille, olitpa sitten konkari tai
                        vasta-alkaja. Kirsi ja Maija ovat jälleen puikoissa vetämässä meille varmasti jotain
                        ainutkertaista. Treenin jälkeen voi jäädä vielä nauttimaan mukillisen glögiä sekä vaihtamaan
                        kuulumisia.</p>
                    <p>Torstaina on siis vain yksi ryhmätreeni!</p>
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/Maija_Kirsi.jpg"/>
                </div>
            </div>


        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
